import React, { useEffect, useState } from 'react'
import { useAuthContext } from '../../hooks/useAuthContext'
import { previewService } from '../../services/previewService'
import { Box, Dialog, IconButton, Typography, CircularProgress } from '@mui/material'
import PagePreview from './components/PagePreview'
import { HighlightOff } from '@mui/icons-material'
import AdditionalNotes from './components/AdditionalNotes'
import { useResponsiveTypography } from '../../utility/responsiveTypography'
import Queries from './components/Queries'
import OverallComments from './components/OverallComments'
import { CURRENCY_COUNTRY_CODE } from '../../utility/constants'
import { CURRENCY_ERROR } from '../../pages/DataEntryPage/utils/currency'

import './Style.css'
import ExportExcelData from '../Dashboard/ExportExcelData'

const DataPreview = ({
  processId,
  onClose,
  open,
  setLoading,
  onSubmit,
  routeTemplateId,
  isSubmission = false,
}) => {
  const { heading, subheading } = useResponsiveTypography()

  const { user } = useAuthContext()
  const [previewData, setPreviewData] = useState(null)

  const getPreviewData = async () => {
    // call api here
    const previewData = await previewService.getPreviewData(user, processId)
    console.log('Preview Data:', previewData)
    return previewData
  }

  useEffect(() => {
    ;(async () => {
      const previewData = await getPreviewData(user, processId)
      setPreviewData(previewData)
    })()
  }, [processId])

  const previewCurrency = previewData?.ndc.reduce((acc, item) => {
    // Use the field_template_id as key and look up the currency symbol from CURRENCY_COUNTRY_CODE
    acc[item.field_template_id] = CURRENCY_COUNTRY_CODE[item.currency_code] || CURRENCY_ERROR
    return acc
  }, {})

  return (
    <Dialog
      className="preview-root"
      onClose={onClose}
      open={open}
      style={{ overflowY: 'scroll', margin: 64, borderRadius: 8 }}
      fullScreen
    >
      {previewData == null ? (
        <Box
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
              width: '100%',
              minWidth: 600,
              maxWidth: 800,
              padding: '20px',
              height: 100,
            }}
          >
            <CircularProgress color="primary" size={24} />
            <Typography>Loading Preview</Typography>
          </Box>
        </Box>
      ) : (
        <Box
          className="preview-page"
          style={{
            padding: '0px 24px 24px 24px',
            overflowX: 'hidden',
            width: '100%',
            maxWidth: '100%',
          }}
        >
          <Box
            className="preview-header"
            style={{ display: 'flex', justifyContent: 'space-between' }}
          >
            <Box>
              <Typography
                className="textPrimary fontWeight700"
                variant="h6"
                sx={{ fontSize: heading }}
              >
                {previewData?.data?.activity_template_name} (Preview)
              </Typography>

              <Typography className="textprimaryblue fontWeight600" sx={{ fontSize: subheading }}>
                {previewData?.data.prefix}-{previewData?.data.process_reference_num} (version:{' '}
                {previewData?.data?.version})
              </Typography>
            </Box>
            <Box>
              <ExportExcelData processId={processId} />
              <IconButton onClick={() => onClose()}>
                <HighlightOff />
              </IconButton>
            </Box>
          </Box>
          {previewData?.pages
            ?.sort((a, b) => a.sequence - b.sequence)
            ?.map((page, index) => {
              const fields = previewData?.fields.filter((it) => it.page_template_id == page.id)
              return (
                <PagePreview
                  key={page.id}
                  index={index}
                  counts={previewData?.pages?.length}
                  page={page}
                  fields={fields}
                  data={previewData?.data}
                  listData={previewData?.listData}
                  dynamicListData={previewData?.dynamicListData}
                  tableSubfieldMap={previewData.tableSubfieldMap}
                  tableSequenceAndHeaders={previewData.tableSequenceAndHeaders}
                  activityType={previewData.data.activity_type}
                  previewCurrency={previewCurrency}
                  processId={processId}
                  isPreview={true}
                  defaultCurrency={previewData?.companyDetails?.default_currency_code}
                />
              )
            })}
          <Queries queries={previewData?.queries} />
          <AdditionalNotes
            additionalNotes={previewData?.additionalNotes}
            activityType={previewData?.data.activity_type}
          />
          {isSubmission && (
            <OverallComments
              setLoading={setLoading}
              onSubmit={onSubmit}
              routeTemplateId={routeTemplateId}
            />
          )}
        </Box>
      )}
    </Dialog>
  )
}

export default DataPreview
